import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const GetCategoriesListSlice = createSlice({
    name: "getCategoriesList",
    initialState,
    reducers: {
        getCategoriesListRequest(state) {
            state.loading = true;
        },
        getCategoriesListRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getCategoriesListRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    getCategoriesListRequest,
    getCategoriesListRequestSuccess,
    getCategoriesListRequestError,
} = GetCategoriesListSlice.actions;

export default GetCategoriesListSlice.reducer;
